export function togglePlayPause(playBtnId, pauseBtnId) {
    const playBtn = document.getElementById(playBtnId);
    const pauseBtn = document.getElementById(pauseBtnId);

    if (!playBtn || !pauseBtn) {
      return;
    }
  
    playBtn.addEventListener('click', () => {
      playBtn.style.display = 'none';
      pauseBtn.style.display = 'block';
    });
  
    pauseBtn.addEventListener('click', () => {
      pauseBtn.style.display = 'none';
      playBtn.style.display = 'block';
    });
}

export function audioBlocks() {
  const audioBlocks = document.querySelectorAll('.listen-article.audio-player-block');

  audioBlocks.forEach(block => {
      const playerIcon = block.querySelector('.player-icon');
      const audioPlayer = block.querySelector('.full-audio-player');
      const audio = audioPlayer?.querySelector('audio');

      playerIcon?.addEventListener('click', function() {
          const isHidden = audioPlayer.classList.contains('hidden');

          if (!isHidden) {
              audioPlayer.classList.add('hidden');
              if (audio && !audio.paused) {
                  audio.pause();
              }
          } else {
              audioPlayer.classList.remove('hidden');
          }
      });

      // Keyboard accessibility
      playerIcon?.addEventListener('keydown', function(e) {
          if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              this.click();
          }
      });

      if (playerIcon && !playerIcon.hasAttribute('tabindex')) {
          playerIcon.setAttribute('tabindex', '0');
      }
  });

}